import React,{ useEffect }  from 'react'
import '../../assets/css/PrivacyPolicy.css'
import Footer from "../HomeLandingComp/FooterComp/Footer";
const PrivacyAndPolicy = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (

    <div className="privacy-container">
      <h1 className="privacy-title">Utharamenon Privacy Policy</h1>
      <p className="privacy-text">
        This Privacy Policy describes how Utharamenon (the "Site", "we", "us", or "our") collects, uses, and discloses your personal information when you visit,
        use our services, or make a purchase from (the "Site") or otherwise communicate with us (collectively, the "Services"). For purposes of this Privacy
        Policy, "you" and "your" means you as the user of the Services, whether you are a customer, website visitor, or another individual whose information
        we have collected pursuant to this Privacy Policy.
      </p>
      <p className="privacy-text">
        Please read this Privacy Policy carefully. By using and accessing any of the Services, you agree to the collection, use, and disclosure of your
        information as described in this Privacy Policy. If you do not agree to this Privacy Policy, please do not use or access any of the Services.
      </p>

      <h2 className="privacy-heading">Changes to This Privacy Policy</h2>
      <p className="privacy-text">
        We may update this Privacy Policy from time to time, including to reflect changes to our practices or for other operational, legal, or regulatory
        reasons. We will post the revised Privacy Policy on the Site, update the "Last updated" date and take any other steps required by applicable law.
      </p>

      <h2 className="privacy-heading">How We Collect and Use Your Personal Information</h2>

      <p className="privacy-text">
        we may use information we collect about you to communicate with you, provide the Services, comply
        with any applicable legal obligations, enforce any applicable terms of service, and to protect or defend the Services, our rights, and the rights of our
        users or others.
      </p>

      <h2 className="privacy-heading">Your Rights</h2>
      <p className="privacy-text">
        Depending on your location, you may have rights such as access to your data, the right to request deletion, and the ability to opt out of certain data processing activities.
      </p>

      <h2 className="privacy-heading">What Personal Information We Collect</h2>
      <p className="privacy-text">
        The types of personal information we obtain about you depends on how you interact with our Site and use our Services. When we use the term
        "personal information", we are referring to information that identifies, relates to, describes or can be associated with you. The following sections
        describe the categories and specific types of personal information we collect.
      </p>

      <h2 className="privacy-heading">Information We Collect Directly from You</h2>
      <p className="privacy-text">
        Information that you directly submit to us through our Services may include:
      </p>
      <ul className="privacy-list">
        <li>Basic contact details name, address, phone number, email.</li>
        <li>Order information including your name, billing address, shipping address, payment confirmation, email address, phone number.</li>
        <li>Customer support information including the information you choose to include in communications with us, for example, when sending a message
          through the Services.</li>
      </ul>
      <p className="privacy-text">
        Some features of the Services may require you to directly provide us with certain information about yourself. You may elect not to provide this
        information, but doing so may prevent you from using or accessing these features.
      </p>

      <h2 className="privacy-heading">How We Use Your Personal Information</h2>

      <ul className="privacy-list">
        <li>Providing Products and Services. We use your personal information to provide you with the Services in order to perform our contract with you,
          including to process your payments, fulfill your orders, to send notifications to you related to you account, purchases, returns, exchanges or other
          transactions, to create, maintain and otherwise manage your account, to arrange for shipping, facilitate any returns and exchanges and to enable
          you to post reviews.</li>
        <li>Marketing and Advertising. We use your personal information for marketing and promotional purposes, such as to send marketing, advertising and
          promotional communications by email, text message or postal mail, and to show you advertisements for products or services. This may include using
          your personal information to better tailor the Services and advertising on our Site and other websites.</li>
        <li>Communicating with you. We use your personal information to provide you with customer support and improve our Services. This is in our
          legitimate interests in order to be responsive to you, to provide effective services to you, and to maintain our business relationship with you.</li>
      </ul>

      {/* <h2 className="privacy-heading">How We Disclose Personal Information</h2>
      <p className="privacy-text">
        In certain circumstances, we may disclose your personal information to third parties for legitimate purposes subject to this Privacy Policy. Such
        circumstances may include:
      </p>

      <ul className="privacy-list">
        <li>With vendors or other third parties who perform services on our behalf (e.g., IT management, payment processing, data analytics, customer support,
          cloud storage, fulfillment and shipping).</li>
        <li>With business and marketing partners, including Shopify, to provide services and advertise to you. Our business and marketing partners will use your information in accordance with their own privacy notices.</li>
        <li>When you direct, request us or otherwise consent to our disclosure of certain information to third parties, such as to ship you products or through
          your use of social media widgets or login integrations, with your consent.</li>
        <li>With our affiliates or otherwise within our corporate group, in our legitimate interests to run a successful business.</li>
        <li>In connection with a business transaction such as a merger or bankruptcy, to comply with any applicable legal obligations (including to respond to
          subpoenas, search warrants and similar requests), to enforce any applicable terms of service, and to protect or defend the Services, our rights, and
          the rights of our users or others.</li>
      </ul> */}

      {/* <p className="privacy-text">
        We have, in the past 12 months disclosed the following categories of personal information and sensitive personal information (denoted by *) about
        users for the purposes set out above in "How we Collect and Use your Personal Information" and "How we Disclose Personal Information":
      </p> */}

      <h2 className="privacy-heading">Category:</h2>
      <ul className="privacy-list">
        <li>Identifiers such as basic contact details and certain order and account information</li>
        <li>Commercial information such as order information, shopping information and customer support information</li>
        <li>Internet or other similar network activity, such as Usage Data</li>
      </ul>
      <h2 className="privacy-heading">Categories of Recipients:</h2>
      <ul className="privacy-list">
        <li>Vendors and third parties who perform services on our behalf (such as Internet service providers, payment processors, fulfillment partners,
          customer support partners and data analytics providers)</li>
        <li>Business and marketing partners</li>
        <li>Affiliates</li>
      </ul>

      <p className="privacy-text">We do not use or disclose sensitive personal information for the purposes of inferring characteristics about you.</p>
      <p className="privacy-text">We have "sold" and "shared" (as those terms are defined in applicable law) personal information over the preceding 12 months for the purpose of
        engaging in advertising and marketing activities, as follows.</p>

      <h2 className="privacy-heading">Category of Personal Information</h2>
      <ul className="privacy-list">
        <li>Identifiers such as basic contact details and certain order and account information</li>
        <li>Commercial information such as records of products or services purchased and shopping information</li>
        <li>Internet or other similar network activity, such as Usage Data</li>
      </ul>
      <h2 className="privacy-heading">Categories of Recipients</h2>
      <ul className="privacy-list">
        <li>Business and marketing partners</li>
      </ul>
      {/* <h2 className="privacy-heading">User Generated Content</h2>
      <p className="privacy-text">The Services may enable you to post product reviews and other user-generated content. If you choose to submit user generated content to any public
        area of the Services, this content will be public and accessible by anyone.</p>
      <p className="privacy-text">We do not control who will have access to the information that you choose to make available to others, and cannot ensure that parties who have
        access to such information will respect your privacy or keep it secure. We are not responsible for the privacy or security of any information that you
        make publicly available, or for the accuracy, use or misuse of any information that you disclose or receive from third parties.</p> */}

      <h2 className="privacy-heading">Third Party Websites and Links</h2>
      <p className="privacy-text">Our Site may provide links to websites or other online platforms operated by third parties. If you follow links to sites not affiliated or controlled by us, you should review their privacy and security policies and other terms and conditions. We do not guarantee and are not responsible for the privacy or
        security of such sites, including the accuracy, completeness, or reliability of information found on these sites. Information you provide on public or
        semi-public venues, including information you share on third-party social networking platforms may also be viewable by other users of the Services
        and/or users of those third-party platforms without limitation as to its use by us or by a third party. Our inclusion of such links does not, by itself,
        imply any endorsement of the content on such platforms or of their owners or operators, except as disclosed on the Services.</p>

      <h2 className="privacy-heading">Children's Data</h2>
      <p className="privacy-text">The Services are not intended to be used by children, and we do not knowingly collect any personal information about children. If you are the parent
        or guardian of a child who has provided us with their personal information, you may contact us using the contact details set out below to request that
        it be deleted.</p>
      <p className="privacy-text">As of the Effective Date of this Privacy Policy, we do not have actual knowledge that we "share" or "sell" (as those terms are defined in applicable law)
        personal information of individuals under 16 years of age.</p>

      <h2 className="privacy-heading">Security and Retention of Your Information</h2>
      <p className="privacy-text">Please be aware that no security measures are perfect or impenetrable, and we cannot guarantee "perfect security." In addition, any information you
        send to us may not be secure while in transit. We recommend that you do not use unsecure channels to communicate sensitive or confidential
        information to us.</p>
      
        {/* <Footer /> */}
    </div>
  )
}


export default PrivacyAndPolicy